// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"data-table_dataTable__1UC4G","tableWrapper":"data-table_tableWrapper__2MLAO"};